import { useEffect, useRef, useState } from "react";

// 15s, 30s, 1 min, 2 min, then every 5 min.
export const RETRY_DELAYS = [15000, 30000, 60000, 120000, 300000];

// While `waiting` is true, calls `retry` on a growing delay, and straight away
// when the connection returns or the teacher comes back to the app.
const useAutoRetry = (waiting, retry) => {
  const [attempt, setAttempt] = useState(0);
  const retryRef = useRef(retry);

  useEffect(() => {
    retryRef.current = retry;
  }, [retry]);

  useEffect(() => {
    if (!waiting) setAttempt(0);
  }, [waiting]);

  useEffect(() => {
    if (!waiting) return undefined;

    const run = () => {
      setAttempt((n) => n + 1);
      retryRef.current();
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") run();
    };

    const timer = setTimeout(
      run,
      RETRY_DELAYS[Math.min(attempt, RETRY_DELAYS.length - 1)]
    );
    window.addEventListener("online", run);
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("online", run);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [waiting, attempt]);
};

export default useAutoRetry;
